// Module
var code = "<div class=\"clinical-update-sub-nav clinical-resources-subpage-container\"><p flex=\"100\" flex-sm=\"100\" flex-xs=\"100\">{{rbhvm.headerContent}}</p><iframe id=\"resources-by-health-dynamic\" ng-src=\"{{frameUrl}}\"></iframe></div>";
// Exports
module.exports = code;